<template>


    <q-card class="shadow-0">
        <q-dialog v-model="dialogVisualizador" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Vista previa PDF</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="text-center">
                        <q-btn icon="download" flat label="Descargar PDF" color="primary" @click="descargarPDF" />
                    </div>
                    <VistasPreviasPDF></VistasPreviasPDF>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-card-section>
            <div class="text-h6">Subir archivo PDF</div>
            <div class="text-subtitle2 text-grey">Arrastra y suelta tu PDF o haz clic para seleccionar uno</div>
        </q-card-section>
        <q-separator />
        <q-card-section>
            <div v-if="persona == 'fisica'" class="row q-col-gutter-md">
                <div class="col-12 doc-note-v" v-if="archivoF1">
                    <div class="row  ">
                        <p class="doc-note__title-v">INE</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document" @click="VerArchivo('ine')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivoF1 = false" />
                    </div>
                    <p class="">El comprobante del INE, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='INE' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfigF1"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivoF2">
                    <div class="row ">
                        <p class="doc-note__title-v">Comprobante de domicilio</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('comprobante_domicilio')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivoF2 = false" />
                    </div>
                    <p class="">El Comprobante de domicilio, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Comprobante de domicilio' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfigF2"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivoF3">
                    <div class="row  ">
                        <p class="doc-note__title-v">RFC</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document" @click="VerArchivo('rfc')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivoF3 = false" />
                    </div>
                    <p class="">El Registro Federal de Contribuyentes, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='RFC' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfigF3"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>
                <div class="col-12 doc-note-v" v-if="archivoF4">
                    <div class="row ">
                        <p class="doc-note__title-v">Comprobante de Ingresos</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('comprobante_ingresos')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivoF4 = false" />
                    </div>
                    <p class="">El documento de Comprobante de Ingresos, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Comprobante de Ingresos' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfigF4"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivoF5">
                    <div class="row ">
                        <p class="doc-note__title-v">Estado de Cuenta Mes 1</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estados_cuenta')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivoF5 = false" />
                    </div>
                    <p class="">El documento del Estado de Cuenta del Mes 1, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estado de Cuenta Mes 1' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfigF5"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivoF7">
                    <div class="row ">
                        <p class="doc-note__title-v">Estado de Cuenta Mes 2</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estados_cuenta_2')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivoF7 = false" />
                    </div>
                    <p class="">El documento del Estado de Cuenta del Mes 2, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estado de Cuenta Mes 2' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfigF7"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivoF8">
                    <div class="row ">
                        <p class="doc-note__title-v">Estado de Cuenta Mes 3</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estados_cuenta_3')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivoF8 = false" />
                    </div>
                    <p class="">El documento del Estado de Cuenta del Mes 3, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estado de Cuenta Mes 3' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfigF8"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivoF6">
                    <div class="row  ">
                        <p class="doc-note__title-v">Documento 1: Declaración Anual del Ejercicio Anterior</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('declaracion_anual')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivoF6 = false" />
                    </div>
                    <p class="">El documento 1 de la Declaración Anual del Ejercicio Anterior, ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Documento 1: Declaración Anual del Ejercicio Anterior'
                        :allow-multiple="false" :accepted-file-types="['application/pdf']" :max-file-size="'20MB'"
                        :server="serverConfigF6" @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivoF9">
                    <div class="row  ">
                        <p class="doc-note__title-v">Documento 2: Declaración Anual del Ejercicio Anterior</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('declaracion_anual_2')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivoF9 = false" />
                    </div>
                    <p class="">El documento 2 de la Declaración Anual del Ejercicio Anterior, ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Documento 2: Declaración Anual del Ejercicio Anterior'
                        :allow-multiple="false" :accepted-file-types="['application/pdf']" :max-file-size="'20MB'"
                        :server="serverConfigF9" @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivoF10">
                    <div class="row  ">
                        <p class="doc-note__title-v">Documento 3: Declaración Anual del Ejercicio Anterior</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('declaracion_anual_3')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivoF10 = false" />
                    </div>
                    <p class="">El documento 3 de la Declaración Anual del Ejercicio Anterior, ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Documento 3: Declaración Anual del Ejercicio Anterior'
                        :allow-multiple="false" :accepted-file-types="['application/pdf']" :max-file-size="'20MB'"
                        :server="serverConfigF10" @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>
            </div>

            <div v-if="persona == 'moral'" class="row q-col-gutter-md">
                <div class="col-12 doc-note-v" v-if="archivo1">
                    <div class="row ">
                        <p class="doc-note__title-v">Acta constitutiva</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('acta_constitutiva')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo1 = false" />
                    </div>
                    <p class="">El documento del Acta constitutiva, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Acta constitutiva' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo2">
                    <div class="row ">
                        <p class="doc-note__title-v">Actas de asamblea</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document" @click="VerArchivo('acta_asamblea')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo2 = false" />
                    </div>
                    <p class="">El documento de las Actas de asamblea, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Actas de asamblea' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig2"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo3">
                    <div class="row ">
                        <p class="doc-note__title-v">Declaración Anual (Ejercicio 1)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('declaracion_anual')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo3 = false" />
                    </div>
                    <p class="">El documento de la Declaración Anual (Ejercicio 1), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Declaración Anual (Ejercicio 1)' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig3"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo11">
                    <div class="row ">
                        <p class="doc-note__title-v">Declaración Anual (Ejercicio 2)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('declaracion_anual_2')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo11 = false" />
                    </div>
                    <p class="">El documento de la Declaración Anual (Ejercicio 2), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Declaración Anual (Ejercicio 2)' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig11"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo12">
                    <div class="row ">
                        <p class="doc-note__title-v">Declaración Anual (Ejercicio 3)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('declaracion_anual_3')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo12 = false" />
                    </div>
                    <p class="">El documento de la Declaración Anual (Ejercicio 3), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Declaración Anual (Ejercicio 3)' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig12"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>


                <div class="col-12 doc-note-v" v-if="archivo4">
                    <div class="row ">
                        <p class="doc-note__title-v">Estados Financieros (Ejercicio 1)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estados_financieros')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo4 = false" />
                    </div>
                    <p class="">El documento del Estados Financieros (Ejercicio 1), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estados Financieros (Ejercicio 1)' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig4"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo13">
                    <div class="row ">
                        <p class="doc-note__title-v">Estados Financieros (Ejercicio 2)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estados_financieros_2')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo13 = false" />
                    </div>
                    <p class="">El documento del Estados Financieros (Ejercicio 2), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estados Financieros (Ejercicio 2)' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig13"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo14">
                    <div class="row ">
                        <p class="doc-note__title-v">Estados Financieros (Ejercicio 3)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estados_financieros_3')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo14 = false" />
                    </div>
                    <p class="">El documento del Estados Financieros (Ejercicio 3), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estados Financieros (Ejercicio 3)' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig14"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo5">
                    <div class="row ">
                        <p class="doc-note__title-v">Estado de cuenta de los ultimos 6 meses (Mes 1)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document" @click="VerArchivo('estado_cuenta')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo5 = false" />
                    </div>
                    <p class="">El documento del Estado de cuenta de los ultimos 6 meses (Mes 1), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estado de cuenta de los ultimos 6 meses (Mes 1)'
                        :allow-multiple="false" :accepted-file-types="['application/pdf']" :max-file-size="'20MB'"
                        :server="serverConfig5" @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo15">
                    <div class="row ">
                        <p class="doc-note__title-v">Estado de cuenta de los ultimos 6 meses (Mes 2)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estado_cuenta_2')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo15 = false" />
                    </div>
                    <p class="">El documento del Estado de cuenta de los ultimos 6 meses (Mes 2), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estado de cuenta de los ultimos 6 meses (Mes 2)'
                        :allow-multiple="false" :accepted-file-types="['application/pdf']" :max-file-size="'20MB'"
                        :server="serverConfig15" @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo16">
                    <div class="row ">
                        <p class="doc-note__title-v">Estado de cuenta de los ultimos 6 meses (Mes 3)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estado_cuenta_3')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo16 = false" />
                    </div>
                    <p class="">El documento del Estado de cuenta de los ultimos 6 meses (Mes 3), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estado de cuenta de los ultimos 6 meses (Mes 3)'
                        :allow-multiple="false" :accepted-file-types="['application/pdf']" :max-file-size="'20MB'"
                        :server="serverConfig16" @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo17">
                    <div class="row ">
                        <p class="doc-note__title-v">Estado de cuenta de los ultimos 6 meses (Mes 4)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estado_cuenta_4')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo17 = false" />
                    </div>
                    <p class="">El documento del Estado de cuenta de los ultimos 6 meses (Mes 4), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estado de cuenta de los ultimos 6 meses (Mes 4)'
                        :allow-multiple="false" :accepted-file-types="['application/pdf']" :max-file-size="'20MB'"
                        :server="serverConfig17" @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo18">
                    <div class="row ">
                        <p class="doc-note__title-v">Estado de cuenta de los ultimos 6 meses (Mes 5)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estado_cuenta_5')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo18 = false" />
                    </div>
                    <p class="">El documento del Estado de cuenta de los ultimos 6 meses (Mes 5), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estado de cuenta de los ultimos 6 meses (Mes 5)'
                        :allow-multiple="false" :accepted-file-types="['application/pdf']" :max-file-size="'20MB'"
                        :server="serverConfig18" @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo19">
                    <div class="row ">
                        <p class="doc-note__title-v">Estado de cuenta de los ultimos 6 meses (Mes 6)</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('estado_cuenta_6')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo19 = false" />
                    </div>
                    <p class="">El documento del Estado de cuenta de los ultimos 6 meses (Mes 6), ya esta cargado en el
                        sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Estado de cuenta de los ultimos 6 meses (Mes 6)'
                        :allow-multiple="false" :accepted-file-types="['application/pdf']" :max-file-size="'20MB'"
                        :server="serverConfig19" @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>

                <div class="col-12 doc-note-v" v-if="archivo6">
                    <div class="row ">
                        <p class="doc-note__title-v">INE Representante Legal</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document" @click="VerArchivo('ine')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo6 = false" />
                    </div>
                    <p class="">El documento del INE Representante Legal, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='INE Representante Legal' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig6"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>
                <div class="col-12 doc-note-v" v-if="archivo7">
                    <div class="row ">
                        <p class="doc-note__title-v">Comprobante de domicilio</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('comprobante_domicilio')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo7 = false" />
                    </div>
                    <p class="">El documento del Comprobante de domicilio, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Comprobante de domicilio' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig7"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>
                <div class="col-12 doc-note-v" v-if="archivo8">
                    <div class="row ">
                        <p class="doc-note__title-v">32-D</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document" @click="VerArchivo('32d')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo8 = false" />
                    </div>
                    <p class="">El documento 32-D, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='32-D' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig8"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>
                <div class="col-12 doc-note-v" v-if="archivo9">
                    <div class="row ">
                        <p class="doc-note__title-v">Buro de Crédito de la Persona Moral</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('buro_credito_moral')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo9 = false" />
                    </div>
                    <p class="">El documento Buro de Crédito de la Persona Moral, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Buro de Crédito de la Persona Moral' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig9"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>
                <div class="col-12 doc-note-v" v-if="archivo10">
                    <div class="row">
                        <p class="doc-note__title-v">Buro de Crédito del Representante Legal</p>
                        <q-space />
                        <q-btn flat round color="green" icon="mdi-file-document"
                            @click="VerArchivo('buro_credito_representante')" />
                        <q-btn flat round color="green" icon="mdi-refresh" @click="archivo10 = false" />
                    </div>
                    <p class="">El documento Buro de Crédito del Representante Legal, ya esta cargado en el sistema.</p>
                </div>
                <div class="col-12" v-else>
                    <file-pond name="file" label-idle='Buro de Crédito del Representante Legal' :allow-multiple="false"
                        :accepted-file-types="['application/pdf']" :max-file-size="'20MB'" :server="serverConfig10"
                        @processfile="onUploadSuccess" @processfileerror="onUploadError" />
                </div>
            </div>
        </q-card-section>
    </q-card>
</template>

<script>
import vueFilePond from 'vue-filepond'

// Importa plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'

// Importa estilos
import 'filepond/dist/filepond.min.css'
import axios from "axios";
import { QSpinnerClock } from 'quasar'
const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginFileValidateSize
)
import VistasPreviasPDF from '../../PDF/VistasPreviasPDF.vue';
export default {
    name: 'SubirPdfFilePond',
    components: {
        FilePond,
        VistasPreviasPDF
    },
    data() {
        return {
            persona: '',
            archivoF1: false,
            archivoF2: false,
            archivoF3: false,
            archivoF4: false,
            archivoF5: false,
            archivoF6: false,
            archivoF7: false,
            archivoF8: false,
            archivoF9: false,
            archivoF10: false,

            archivo1: false,
            archivo2: false,
            archivo3: false,
            archivo4: false,
            archivo5: false,
            archivo6: false,
            archivo7: false,
            archivo8: false,
            archivo9: false,
            archivo10: false,
            archivo11: false,
            archivo12: false,
            archivo13: false,
            archivo14: false,
            archivo15: false,
            archivo16: false,
            archivo17: false,
            archivo18: false,
            archivo19: false,
            dialogVisualizador: false,

            serverConfig: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'acta_constitutiva'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo1 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig2: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'acta_asamblea'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo2 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig3: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'declaracion_anual'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo3 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig4: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← A-quí va el ID del usuario
                    formData.append('tipoDocumento', 'estados_financieros'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo4 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig5: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estado_cuenta'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo5 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig6: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'ine'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo6 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig7: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'comprobante_domicilio'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo7 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig8: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', '32d'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo7 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig9: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'buro_credito_moral'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo9 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig10: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'buro_credito_representante'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo10 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig11: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'declaracion_anual_2'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo11 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig12: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'declaracion_anual_3'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo12 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig13: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estados_financieros_2'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo13 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig14: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estados_financieros_3'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo14 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig15: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estado_cuenta_2'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo15 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig16: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estado_cuenta_3'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo16 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig17: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estado_cuenta_4'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo17 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig18: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estado_cuenta_5'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo18 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfig19: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estado_cuenta_6'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivo19 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },

            serverConfigF1: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'ine'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivoF1 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfigF2: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'comprobante_domicilio'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivoF2 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfigF3: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'rfc'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivoF3 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfigF4: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'comprobante_ingresos'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivoF4 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfigF5: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estados_cuenta'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivoF5 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfigF6: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'declaracion_anual'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivoF6 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfigF7: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estados_cuenta_2'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivoF7 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfigF8: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'estados_cuenta_3'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivoF8 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfigF9: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'declaracion_anual_2'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivoF9 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
            serverConfigF10: {
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('userId', this.userStore._id_cliente); // ← Aquí va el ID del usuario
                    formData.append('tipoDocumento', 'declaracion_anual_3'); // ← Aquí el tipo

                    const request = new XMLHttpRequest();
                    request.open('POST', 'https://api-arrendafit.contago.com.mx/api/Documentos/SubirArchivo');

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };

                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            this.archivoF10 = JSON.parse(request.response)
                            console.log("Archivo guardado:", request.response);
                            load(request.responseText);
                        } else {
                            error('Error al subir');
                        }
                    };

                    request.send(formData);

                    return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                    };
                }
            },
        };
    },
    computed: {
        userStore() {
            return this.$store.state.auth.clienteStore;
        },
    },
    created() {
        this.obtenerPerfil()
        this.GetDocF1();
        this.GetDocF2();
        this.GetDocF3();
        this.GetDocF4();
        this.GetDocF5();
        this.GetDocF6();
        this.GetDocF7();
        this.GetDocF8();
        this.GetDocF9();
        this.GetDocF10();
        this.GetDoc1();
        this.GetDoc2();
        this.GetDoc3();
        this.GetDoc4();
        this.GetDoc5();
        this.GetDoc6();
        this.GetDoc7();
        this.GetDoc8();
        this.GetDoc9();
        this.GetDoc10();
        this.GetDoc11();
        this.GetDoc12();
        this.GetDoc13();
        this.GetDoc14();
        this.GetDoc15();
        this.GetDoc16();
        this.GetDoc17();
        this.GetDoc18();
        this.GetDoc19();
    },
    methods: {
        async GetDoc1() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/acta_constitutiva')
                console.log(respuesa)
                this.archivo1 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc2() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/acta_asamblea')
                console.log(respuesa)
                this.archivo2 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc3() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/declaracion_anual')
                console.log(respuesa)
                this.archivo3 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc4() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estados_financieros')
                console.log(respuesa)
                this.archivo4 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc5() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estado_cuenta')
                console.log(respuesa)
                this.archivo5 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc6() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/ine')
                console.log(respuesa)
                this.archivo6 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc7() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/comprobante_domicilio')
                console.log(respuesa)
                this.archivo7 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc8() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/32d')
                console.log(respuesa)
                this.archivo8 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc9() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/buro_credito_moral')
                console.log(respuesa)
                this.archivo9 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc10() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/buro_credito_representante')
                console.log(respuesa)
                this.archivo10 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc11() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/declaracion_anual_2')
                console.log(respuesa)
                this.archivo11 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc12() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/declaracion_anual_3')
                console.log(respuesa)
                this.archivo12 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc13() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estados_financieros_2')
                console.log(respuesa)
                this.archivo13 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc14() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estados_financieros_3')
                console.log(respuesa)
                this.archivo14 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc15() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estado_cuenta_2')
                console.log(respuesa)
                this.archivo15 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc16() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estado_cuenta_3')
                console.log(respuesa)
                this.archivo16 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc17() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estado_cuenta_4')
                console.log(respuesa)
                this.archivo17 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc18() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estado_cuenta_5')
                console.log(respuesa)
                this.archivo18 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDoc19() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estado_cuenta_6')
                console.log(respuesa)
                this.archivo19 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },

        async GetDocF1() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/ine')
                console.log(respuesa)
                this.archivoF1 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDocF2() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/comprobante_domicilio')
                console.log(respuesa)
                this.archivoF2 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDocF3() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/rfc')
                console.log(respuesa)
                this.archivoF3 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDocF4() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/comprobante_ingresos')
                console.log(respuesa)
                this.archivoF4 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDocF5() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estados_cuenta')
                console.log(respuesa)
                this.archivoF5 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDocF6() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/declaracion_anual')
                console.log(respuesa)
                this.archivoF6 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDocF7() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estados_cuenta_2')
                console.log(respuesa)
                this.archivoF7 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDocF8() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/estados_cuenta_3')
                console.log(respuesa)
                this.archivoF8 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDocF9() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/declaracion_anual_2')
                console.log(respuesa)
                this.archivoF9 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetDocF10() {
            try {
                let respuesa = await axios.get('Documentos/ExisteDocumentoUsuario/' + this.userStore._id_cliente + '/declaracion_anual_3')
                console.log(respuesa)
                this.archivoF10 = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },

        onUploadSuccess(error, file) {
            this.$q.notify({
                type: 'positive',
                position: 'top-right',
                message: 'Archivo subido correctamente'
            });
        },
        onUploadError(error, file) {
            this.$q.notify({
                position: 'top-right', type: 'negative',
                message: 'Error al subir el archivo'
            });
        },

        async obtenerPerfil() {
            try {
                const res = await axios.get('Configuracion/GetDatosFiscalesPorId/' + this.userStore._id_cliente)
                console

                // Validar si la respuesta tiene datos
                if (!res.data || !res.data._id_cliente) {
                    this.$q.notify({
                        position: 'top-right',
                        type: 'negative',
                        message:
                            'Primero deberá subir los datos fiscales de la persona Física o Moral'
                    });
                    return; // detener ejecución
                }

                const rfc = (res.data.rfc || '').trim();

                if (rfc.length === 13) {
                    this.persona = 'fisica';
                } else if (rfc.length === 12) {
                    this.persona = 'moral';
                } else {
                    this.persona = null; // RFC inválido
                    this.$q.notify({
                        position: 'top-right',
                        type: 'warning',
                        message: 'El RFC proporcionado no es válido'
                    });
                }

                console.log('res.data', res.data)
            } catch (err) {
                console.error('Error al obtener perfil:', err)
            }
        },

        async VerArchivo(tipo) {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando documento. Espere...', messageColor: 'white' })

            try {
                const res = await axios.get('Documentos/GetDocumentoTipoUsuario/' + this.userStore._id_cliente + '/' + tipo)
                console.log(res)
                this.documento = res.data
                this.$store.state.auth.storeBase64Cotizacion = 'data:application/pdf;base64,' + this.documento.base64;

                this.dialogVisualizador = true
                this.$q.loading.hide()

            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }

        },

        descargarPDF() {
            const fileName = this.documento.nombreOriginal;
            const link = document.createElement("a");
            link.href = 'data:application/pdf;base64,' + this.documento.base64;
            link.download = fileName;
            link.click();
        },
    }
};
</script>
<style>
.doc-note-v {
    background-color: #f0f4f8;
    border-left: 4px solid #00a308;
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    font-family: Arial, sans-serif;
}

.doc-note__title-v {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #00a308;
    font-size: 20px;
}

.doc-note-v p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>